import { Box, Button, Flex, Text } from '@chakra-ui/react';

const Messages = ({ subscriptionData, setIsOpenPopover, isTestChat }) => {
    return subscriptionData?.map((message, index) => (
        <Flex key={index} justifyContent={message?.audio_preview === null ? 'flex-start' : 'flex-end'} pos='relative'>
            <Box>
                <Box
                    p='10px'
                    mr={message?.audio_preview === null ? '0px' : '10px'}
                    borderRadius='8px'
                    bgColor={
                        message?.audio_preview === null
                            ? `${isTestChat ? 'lightGray' : '#f3f4f6'}`
                            : `${isTestChat ? 'lightYellow' : '#5611F8'}`
                    }
                    color={message?.audio_preview === null ? 'black' : 'white'}
                >
                    <Text>{message?.answer}</Text>
                </Box>
                {message?.audio_preview === null && index !== 0 && (
                    <Button
                        variant='link'
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsOpenPopover((prev) => !prev);
                        }}
                        color='purple.600'
                        cursor='pointer'
                        size='sm'
                    >
                        Fix
                    </Button>
                )}
            </Box>
        </Flex>
    ));
};

export default Messages;
